import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';

export class PacketLabelApiService extends ApiService {
  static endpoint = 'third-parties/packeta/packetLabel';

  /**
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @public
   */
  static async post(data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildUrl(), data, {
      ...config,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
